import { apiService } from './apiService';

const invalidatesCompanyOverview = { invalidatesTags: ['CompanyOverview' as const] };

apiService.enhanceEndpoints({
  endpoints: {
    campaignControllerCampaign: {
      providesTags: (_result, _error, arg) => [{ type: 'Campaign', id: arg.id }],
    },
    handoffRuleCreateControllerExecute: {
      invalidatesTags: [{ type: 'Campaign' }],
    },
    companyOverviewControllerGetCompanyOverview: {
      providesTags: ['CompanyOverview'],
    },
    campaignCreateControllerCampaignCreate: invalidatesCompanyOverview,
    campaignDeleteControllerDeleteCampaign: invalidatesCompanyOverview,
    campaignRunControllerCampaignRun: invalidatesCompanyOverview,
    campaignStopControllerCampaignStop: invalidatesCompanyOverview,
  },
});

export { apiService };
